<template>
  <div class="h-full overflow-auto">
    <div class="mobile-status-padding"></div>
    <div class="py-4"></div>
    <div class="font-bold text-3xl px-6 title-color">Deals & coupons</div>
    <div class="px-6 text-sm">
      Nos restaurants vous proposent des réductions pour toujours faire votre
      plaisir
    </div>
    <div class="py-4"></div>
    <div class="mx-6">
      <div class="bg-slate-100/80 rounded-2xl p-1.5 flex gap-2 shadow-inner">
        <button
          class="flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300"
          :class="[
            visibleTab === 'deals'
              ? 'bg-white text-primary shadow-lg shadow-primary/20'
              : 'text-slate-500 hover:text-slate-700 hover:bg-white/50'
          ]"
          @click="visibleTab = 'deals'"
        >
          Les deals
        </button>
        <button
          class="flex-1 py-2.5 px-3 rounded-xl text-sm font-semibold transition-all duration-300"
          :class="[
            visibleTab === 'coupons'
              ? 'bg-white text-primary shadow-lg shadow-primary/20'
              : 'text-slate-500 hover:text-slate-700 hover:bg-white/50'
          ]"
          @click="visibleTab = 'coupons'"
        >
          Les coupons
        </button>
      </div>
    </div>
    <div class="py-4"></div>
    <DealsList v-if="visibleTab == 'deals'" />
    <CouponsList v-else-if="visibleTab == 'coupons'" />
    <div class="py-4"></div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import DealsList from '../components/DealsList.vue';
import CouponsList from '../components/CouponsList.vue';
import { useRoute } from 'vue-router';

const route = useRoute();

const visibleTab = ref('deals');

onMounted(() => {
  if (/coupon/i.test(route.hash)) {
    visibleTab.value = 'coupons';
  }
});
</script>

<style scoped>
.text-primary {
  color: #f59e0b;
}
</style>
